import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Footer() {
    const currentYear = new Date().getFullYear();
    const location = useLocation(); // الحصول على الموقع الحالي

    const isHomePage = location.pathname === '/'; // التحقق إذا كنت في الصفحة الرئيسية
    return (
        <footer className="py-5">
            <div className="container">
                <div className="row justify-content-between align-items-center text-center text-md-start">
                    <div className="col-md-4 mb-4 mb-md-0">
                        <div className="mb-2">
                            <span className="fw-bold fs-4">مطور</span><span className="text-primary fs-4">ويب</span>
                        </div>
                        <p className="text-muted mb-0">مطور ويب كامل</p>
                    </div>
                   
                    <div className="col-md-4 mb-4 mb-md-0">
                        <ul className="nav justify-content-center justify-content-md-start">
                            <li className="nav-item">
                                {isHomePage ? (
                                    <a className="nav-link" href="#hero">الرئيسية</a>
                                ):(
                                    <Link className='nav-link' to="/" state={{scrollTo:'hero'}}>الرئيسية</Link> 
                                )}
                            </li>
                            <li className="nav-item">
                                {isHomePage ? (
                                    <a className="nav-link" href="#about">عني</a>
                                ):(
                                    <Link className='nav-link' to="/" state={{scrollTo:'about'}}>عني</Link> 
                                )}
                            </li>
                            <li className="nav-item">
                                {isHomePage ? (
                                    <a className="nav-link" href="#skills">المهارات</a>
                                ):(
                                    <Link className='nav-link' to="/" state={{scrollTo:'skills'}}>المهارات</Link> 
                                )}
                            </li>
                            <li className="nav-item">
                                {isHomePage ? (
                                    <a className="nav-link" href="#projects">المشاريع</a>
                                ):(
                                    <Link className='nav-link' to="/" state={{scrollTo:'projects'}}>المشاريع</Link> 
                                )}
                            </li>
                            <li className="nav-item">
                                {isHomePage ? (
                                    <a className="nav-link" href="#contact">اتصل بي</a>
                                ):(
                                    <Link className='nav-link' to="/" state={{scrollTo:'contact'}}>اتصل بي</Link> 
                                )}
                            </li>
                        </ul>
                    </div>
                   
                    <div className="col-md-4">
                        <div className="d-flex justify-content-center justify-content-md-end gap-3">
                            <a href="https://github.com/Salahaldeen77" target='_blank' rel="noreferrer" className="social-link">
                                <i className="fab fa-github"></i>
                            </a>
                            <a href='https://wa.me/967784442005' target='_blank' rel="noreferrer" className="social-link">
                                <i className="fab fa-whatsapp"></i>
                            </a>
                            <a href="https://www.facebook.com/Salahaldeen777988" target='_blank' rel="noreferrer" className="social-link">
                                <i className="fab fa-facebook"></i>
                            </a>
                            {/* <a href="#" className="social-link">
                                <i className="fab fa-linkedin"></i>
                            </a> */}
                            {/* <a href="#" className="social-link">
                                <i className="fab fa-twitter"></i>
                            </a> */}
                        </div>
                    </div>
                </div>
               
                <hr className="my-4 border-secondary" />
               
                <div className="text-center">
                    <p className="mb-0 text-muted">© {currentYear} <span>Alaizari</span> جميع الحقوق محفوظة</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;